module.exports = __webpack_public_path__ + "img/mountains.8b78aee0.svg";